import { render, staticRenderFns } from "./Lgx240135806843355136.vue?vue&type=template&id=3af4cce2&scoped=true&"
import script from "./Lgx240135806843355136.vue?vue&type=script&lang=js&"
export * from "./Lgx240135806843355136.vue?vue&type=script&lang=js&"
import style0 from "./Lgx240135806843355136.vue?vue&type=style&index=0&id=3af4cce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af4cce2",
  null
  
)

export default component.exports